<template>
  <component :is="type + 'Add'" v-if="type" ref="addPerformanceModal" />
</template>
<script>
import PowerAdd from './power/Add'
import GasAdd from './gas/Add'

export default {
  components: {
    PowerAdd,
    GasAdd,
  },
  data() {
    return {
      id: null,
    }
  },
  computed: {
    type() {
      return this.$store.getters['energetic/getCurrentType']
    },
  },
  methods: {
    saveReport(e) {
      e.preventDefault()
      this.$refs.addPerformanceModal.$validator.validateAll().then(() => {
        if (
          !this.$refs.addPerformanceModal.errors.any() &&
          !this.$refs.addPerformanceModal.loading
        ) {
          if (this.id) {
            this.$api
              .post(
                'reports/edit_performance',
                this.$refs.addPerformanceModal.form,
              )
              .then((res) => {
                this.$swal({
                  type: 'success',
                  position: 'top',
                  showCloseButton: true,
                  text: res.data.message,
                  timer: 5000,
                })
                this.$root.$emit('modal-hide', 'add-performance')
                this.$root.$emit('reloadPerformanceReportData')
              })
          } else {
            this.$api
              .post(
                'reports/add_performance',
                this.$refs.addPerformanceModal.form,
              )
              .then((res) => {
                this.$swal({
                  type: 'success',
                  position: 'top',
                  showCloseButton: true,
                  text: res.data.message,
                  timer: 5000,
                })
                this.$root.$emit('modal-hide', 'add-performance')
                this.$root.$emit('reloadPerformanceReportData')
              })
          }
        } else {
          this.$swal({
            type: 'warning',
            position: 'top',
            showCloseButton: true,
            text: 'Formulár nieje správne vyplnený',
            timer: 5000,
          })
        }
      })
    },
  },
}
</script>
